import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import axios from 'axios';
import uploadFormDataToS3 from 'utils/file/uploadFormDataToS3';
// Browsers don't reliably populate `File.type` for every extension - notably
// .srt and .vtt often have no OS-registered MIME type - so derive it from the
// extension instead of trusting `file.type`.
var EXTENSION_CONTENT_TYPES = {
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.vtt': 'text/vtt',
  '.srt': 'application/x-subrip',
  '.txt': 'text/plain'
};
function getContentType(file) {
  var extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
  return EXTENSION_CONTENT_TYPES[extension] || file.type;
}
function uploadMindsetMeetingTranscript(_x) {
  return _uploadMindsetMeetingTranscript.apply(this, arguments);
}
function _uploadMindsetMeetingTranscript() {
  _uploadMindsetMeetingTranscript = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var file, _policy$fields, _yield$axios$post, policy, _error$response, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          file = _ref.file;
          _context.prev = 1;
          _context.next = 2;
          return axios.post('/api/mindset/transcripts/policy', {
            filename: file.name,
            contentType: getContentType(file),
            size: file.size
          });
        case 2:
          _yield$axios$post = _context.sent;
          policy = _yield$axios$post.data.policy;
          _context.next = 3;
          return uploadFormDataToS3({
            policy: policy,
            file: file
          });
        case 3:
          return _context.abrupt("return", policy === null || policy === void 0 || (_policy$fields = policy.fields) === null || _policy$fields === void 0 ? void 0 : _policy$fields.key);
        case 4:
          _context.prev = 4;
          _t = _context["catch"](1);
          _t.formattedErrorMessage = ((_error$response = _t.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error) || _t.message;
          throw _t;
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 4]]);
  }));
  return _uploadMindsetMeetingTranscript.apply(this, arguments);
}
export default uploadMindsetMeetingTranscript;